module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dFhEx"))).then(() => parcelRequire('d0iPb'));